export const SHIPPING_ADDRESS_FORM_ZIPCODE_MIN_CHARACTERS = 4
